/**
 * Struct module
 *
 * @author Joe Ballschneider (jballschneider@yext.com)
 */
goog.provide('yext.location.Struct');
goog.provide('yext.location.GenericList');

goog.require('yext');
goog.require('yext.dam.assetselector.events');
goog.require('yext.dam.assetselector.types');
goog.require('yext.location.Number');
goog.require('yext.location.hours.DayHours');
goog.require('yext.entity.fields.video.YouTubeVideoField');
goog.require('yext.location.custom.times.daily');
goog.require('yext.location.Date');
goog.require('yext.location.RichText');
goog.require('yext.location.image.Image');
goog.require('yext.location.image.ImageField');
goog.require('yext.location.OptionList');
goog.require('yext.location.ReferenceValueList');
goog.require('yext.location.Select');
/** @suppress {extraRequire} */
goog.require('yext.plugins.selectbox');
goog.require('yext.textfield');
goog.require('yext.textfield.TextField');

yext.location.Struct = class {
  constructor($field, context, isChild = false) {
    this.$ctxt = $field;
    this.context = context;
    this.$children = this.$ctxt.find('.js-struct-child')
      .first().siblings('.js-struct-child').addBack();
    this.fieldName = this.$ctxt.find('.js-struct-name').first().attr('data-struct-name');
    this.$viewDisplay =
      this.$ctxt
        .parents('.js-struct-field')
        .find('[data-struct-name=\'' + this.fieldName + '\']')
        .first();
    this.$childWrapper = this.$viewDisplay.find('.js-struct-children-wrapper').first();
    this.$emptyMessage = this.$viewDisplay.find('.emptyvalue').first();
    this.children = this.constructChildren();
    this.$fieldValue = this.$ctxt.find('.js-struct-field-value').first();
    this.$assetIdValue = this.$ctxt.find('.js-struct-asset-id').first();
    this.fieldId = isChild
      ? this.$ctxt.parents('.js-struct-edit, .js-generic-list-edit').last().find('.js-field-id').first().val()
      : this.$ctxt.find('.js-field-id').first().val();
    this.typeId = this.$ctxt.find('.js-struct-type').first().data('structType');
    this.shownEmptyChildren = [];

    this.isAssetsOnly = this.$fieldValue.data('assetsOnly');
    if (this.isAssetsOnly) {
      this.blockInputs();
    }

    this.bindUpdate();
    this.setFieldValue();
    this.bindAssetSelector(isChild);
    this.bindShowChild();
  }

  /**
   * For asset only users block the various inputs a struct child can have. Asset only users
   * should only be able to apply assets and add or delete list items.
   */
  blockInputs() {
    // disable all inputs for any children
    this.$ctxt.find('input').prop('readonly', true);
    this.$ctxt.find('input:checkbox').prop('disabled', true);
    // hide add photo buttons
    this.$ctxt.find('.js-select-photo-button').hide();
    // hide add video buttons
    this.$ctxt.find('.js-add-video').hide();
    // disable and unbind option select boxes
    this.$ctxt.find('.selectbox').css('pointer-events', 'none');
    this.$ctxt.find('.selectbox > a').addClass('disabled');
    // hide hours apply to all buttons
    this.$ctxt.find('.js-hours-apply-to-all').hide();
    // hide daily times apply to all buttons
    this.$ctxt.find('.js-apply-to-all').hide();
    // disable hours type buttons
    this.$ctxt.find('*[class*="js-hours-type-"] > button').prop('disabled', true);
    // disable datepickers
    this.$ctxt.find('.js-date-input').prop('disabled', true);
  }

  /**
   * Empty struct properties begin hidden. When the "+ Add" button is clicked, show them.
   */
  bindShowChild() {
    let self = this;

    this.$ctxt.find('.js-show-struct-child').each(function() {
      let messageContainer = $(this).closest('.js-show-struct-child-message');
      let key = messageContainer.data('associatedPropName');

      $(this).on('click', () => {
        messageContainer.hide();
        self.$ctxt.find('.js-struct-child[data-prop-name=\'' + key + '\']').show();
        self.shownEmptyChildren.push(key);
      });
    });
  }

  /**
   * Binds child updates to struct updates. All children must broadcast an "update.struct"
   * message in order to trigger the struct update.
   */
  bindUpdate() {
    let self = this;

    this.children.forEach(function(child) {
      $(child).on('update.struct', function() {
        $(self).trigger('updated');
        $(self).trigger('update.struct');
        $(self).trigger('update.list');
      });
    });

    this.children.forEach(function(child) {
      $(child).on('nonAssetClearingUpdate.struct', function() {
        $(self).trigger('nonAssetClearingUpdate.struct');
        $(self).trigger('nonAssetClearingUpdate.list');
        $(self).trigger('nonAssetClearingUpdate');
      });
    });

    $(this).on('updated', function() {
      self.$assetIdValue.val('');
      self.setFieldValue();
    });

    $(this).on('nonAssetClearingUpdate', function() {
      self.setFieldValue();
    });
  }

  bindAssetSelector(isChild) {
    if (isChild) {
      this.bindChildStructAssetSelector();
    } else {
      this.bindTopLevelAssetSelector();
    }
  }

  bindTopLevelAssetSelector() {
    // open button for top level is on the row
    let $openButton = this.$ctxt.closest(this.context).find('.js-choose-struct-asset').first();
    let $menu = this.$ctxt.closest(this.context).find('.js-asset-actions-dropdown').first();
    let $applyAsset = this.$ctxt.closest(this.context).find('.js-apply-asset').first();
    let $clearField = this.$ctxt.closest(this.context).find('.js-clear-field').first();

    $openButton.on('click', e => {
      if (!$menu.is(':visible')) {
        $('.js-asset-actions-dropdown').hide();
        $menu.show();
        e.stopPropagation();
      }
    });

    $applyAsset.on('click', () => {
      // The top level asset selector uses its field id because it has one
      yext.dam.assetselector.events.show(
        {
          type: yext.dam.assetselector.types.CUSTOM,
          customFieldTypeId: this.typeId,
          usageType: goog.module.get('yext.dam.assetselector.usage').forProfileFields(this.fieldId),
        },
        this.fieldName);

      $(yext.dam.assetselector.events).on('added.assetselector', (e, asset) => {
        this.applyAsset(JSON.parse(asset.variant));
        this.$assetIdValue.val(asset.id);
      });
    });

    $clearField.on('click', () => {
      this.clear();
    });

    $(document).click(function() {
      $menu.hide();
    });
  }

  bindChildStructAssetSelector() {
    // open button for child struct is next to the field name
    let $openButton =
      this.$ctxt
        .closest('.js-struct-child')
        .prev('.js-struct-child-name')
        .find('.js-choose-child-struct-asset');
    let $container =
      this.$ctxt
        .closest('.js-struct-child')
        .prev('.js-struct-child-name')
        .find('.js-asset-container');

    if (!$openButton.length) {
      // if button is not next to field name, then it is a list item
      $openButton = this.$ctxt.closest('.js-generic-list-item').siblings('.js-choose-item-asset');
      $container = this.$ctxt.closest('.js-generic-list-item').siblings('.js-asset-container');
    }

    let $menu = $container.find('.js-asset-actions-dropdown');
    let $applyAsset = $menu.find('.js-apply-asset');
    let $clearField = $menu.find('.js-clear-field');


    $openButton.on('click', e => {
      if (!$menu.is(':visible')) {
        $('.js-asset-actions-dropdown').hide();
        $menu.show();
        e.stopPropagation();
      }
    });

    $applyAsset.on('click', () => {
      yext.dam.assetselector.events.show(
        {
          // The other asset selector uses its type
          type: yext.dam.assetselector.types.CUSTOM,
          customFieldTypeId: this.typeId,
          usageType: goog.module.get('yext.dam.assetselector.usage').forProfileFields(this.fieldId),
        },
        this.fieldName);

      $(yext.dam.assetselector.events).on('added.assetselector', (e, asset) => {
        this.applyAsset(JSON.parse(asset.variant));
        this.$assetIdValue.val(asset.id);
      });
    });

    $clearField.on('click', () => {
      this.clear();
    });

    $(document).click(function() {
      $menu.hide();
    });
  }

  /**
   * Stores all data for the struct and its children in a single hidden input field to be sent to the
   * controller on submission.
   */
  setFieldValue() {
    let jsonValue = yext.JSON.stringify(this.getJSONData());
    this.$fieldValue.val(jsonValue);
  }

  /**
   * Marshals the JSON of all children to store in the hidden input field. All children must implement
   * a getJSONData function.
   *
   * @return {!Object} JSON containing the data of all child fields.
   */
  getJSONData() {
    let jsonData = {};
    this.children.forEach(function(child, key) {
      jsonData[key] = child.getJSONData();
    });

    if (this.$assetIdValue.val()) {
      jsonData['assetId'] = this.$assetIdValue.val();
    }

    return jsonData;
  }

  /**
   * Clear Struct
   */
  clear() {
    this.children.forEach(function(child, key) {
      child.clear();
    });
    this.clearAsset();
    this.setFieldValue();
  }

  /**
   * Called right before submission, this function reconciles asset ids of the struct and all of
   * its children. If this is an asset submission, fills the field value with JSON data containing
   * any existing asset ids of this struct and its children. If this is an edit submission, clears
   * all asset ids of this struct and its children.
   */
  reconcileAsset() {
    let assetSubmission = this.checkAssetOrOriginalFlag();

    if (assetSubmission) {
      // reconcile asset - add asset ids to json blobs and fill field value hidden input
      let jsonData = this.getJSONData();
      this.$fieldValue.val(yext.JSON.stringify(jsonData));
    } else {
      // edit submission - clear all asset flags
      this.clearAsset();
      this.setFieldValue();
    }
  }

  /**
   * Check the assetOrOriginal flag of all children. If all are true, this is an asset submission.
   * If any are false this is an edit submission.
   */
  checkAssetOrOriginalFlag() {
    this.children.forEach(function(child, key) {
      if (!child.checkAssetOrOriginalFlag()) {
        return false;
      }
    });
    return true;
  }

  /**
   * Clear asset ids from hidden inputs of this struct and all of its children.
   */
  clearAsset() {
    this.$assetIdValue.val('');

    this.children.forEach(function(child, key) {
      // if child type can have asset id, wipe it out
      if (child instanceof yext.location.Struct
          || child instanceof yext.location.GenericList
          || child instanceof yext.entity.fields.video.YouTubeVideoField
          || child instanceof yext.location.image.Image
          || child instanceof yext.textfield.TextField) {
        child.clearAsset();
      }
    });
  }

  /**
   * Reset function for struct. Calls the reset function of all children.
   */
  reset() {
    let self = this;
    this.children.forEach(function(child, key) {
      child.reset();
    });

    this.shownEmptyChildren.forEach(function(key) {
      self.$ctxt.find('.js-struct-child[data-prop-name=\'' + key + '\']').hide();
      self.$ctxt.find('.js-show-struct-child-message[data-associated-prop-name=\'' + key + '\']').show();
    });
    self.shownEmptyChildren = [];
  }

  /**
   * After save function for top tier struct. Calls setFromStruct on all children.
   */
  afterSave(response) {
    const self = this;
    this.children.forEach(function(child, key) {
      child.setFromStruct(
        response.field[key],
        self.$viewDisplay.find('[data-prop-name=\'' + key + '\']'));
    });
    this.$childWrapper.show();
    this.$emptyMessage.hide();
    this.setFieldValue();
    this.clearAsset();
    this.shownEmptyChildren = [];
  }

  /**
   * This is essentially the after save function for a non-top tier struct. Similar to afterSave
   * but treats the parameters slightly differently.
   *
   * @param {!Object} fieldValues       object containing updated data for all the struct properties
   * @param {!Object} $displayFromList  DOM view element to render when the struct is an item of a generic list.
   * @param {!Object} $viewTemplate     view template of the field (only used by video.js)
   */
  setFromStruct(fieldValues, $displayFromList, $viewTemplate, cannotEdit) {
    let $display = $displayFromList ? $displayFromList : this.$viewDisplay;

    this.children.forEach(function(child, key) {
      child.setFromStruct(
        fieldValues[key],
        $display.find('[data-prop-name=\'' + key + '\']'),
        $viewTemplate,
        cannotEdit);
    });
    this.$childWrapper.show();
    this.$emptyMessage.hide();
    this.clearAsset();
    this.shownEmptyChildren = [];
  }

  /**
   * This method recursively modifies those image field values associated with files so they have a
   * 'fileIndex' variable and their 'url' is cleared. The 'fileIndex' corresponds uniquely to which
   * file in the eventual form they correspond to. The behavior in here is similar to what was done in
   * ImageUploader.upload. Finally, the method returns all the files that will need to be uploaded
   * in the form, sorted properly.
   */
  orderAndAssociateImageFiles(
    parsedFieldValue = window.JSON.parse(this.$fieldValue.val()),
    imageFiles = []) {
    this.children.forEach(function(child, key) {
      if (child instanceof yext.location.Struct || child instanceof yext.location.GenericList) {
        child.orderAndAssociateImageFiles(parsedFieldValue[key], imageFiles);
      } else {
        if (child.getAssociatedFile) {
          var associatedFile = child.getAssociatedFile();
          if (!window.jQuery.isEmptyObject(associatedFile)) {
            parsedFieldValue[key]['url'] = undefined;
            parsedFieldValue[key]['fileIndex'] = imageFiles.length;
            imageFiles.push(associatedFile['file']);
          }
        }
      }
    });
    this.$fieldValue.val(window.JSON.stringify(parsedFieldValue));

    return imageFiles;
  }

  /**
   * Similar to setFromStruct, but calls previewAsset on child generic lists. This allows child
   * generic lists to add empty items which is required for showing a generic list that is a
   * struct child in the asset selector.
   */
  previewAsset(fieldValues, $displayFromList, $viewTemplate) {
    let $display = $displayFromList ? $displayFromList : this.$viewDisplay;
    $display.find('.emptyvalue').hide();
    this.$childWrapper.show();

    this.children.forEach(function(child, key) {
      if (child instanceof yext.location.GenericList) {
        child.previewAsset(fieldValues[key], $display.find('[data-prop-name=\'' + key + '\']'));
      } else {
        child.setFromStruct(
          fieldValues[key],
          $display.find('[data-prop-name=\'' + key + '\']'),
          $viewTemplate,
          true /* cannotEdit */);
      }
    });
  }

  /**
   * Apply asset values to all children. Similar to setFromStruct but does not store values into
   * child field's backing models/stored values.
   */
  applyAsset(fieldValues) {
    this.children.forEach(function(child, key) {
      child.applyAsset(fieldValues[key]);
    });
  }

  /**
   * Get timestamp
   *
   * @return {string} Timestamp for struct field
   */
  getTimestamp() {
    return this.$ctxt.find('.js-field-timestamp').first().val();
  }

  /**
   * Helper function to construct child field objects from child selectors.
   *
   * @return {Map} A map of child ids to child fields.
   */
  constructChildren() {
    const self = this;
    let children = new Map();
    this.$children.each(function() {
      let $child = $(this);
      let name = $child.attr('data-prop-name');
      let child = self.constructChild($child);
      children.set(name, child);
    });
    return children;
  }

  /**
   * Constructs a child object from the given context.
   *
   * @param {!Object} $child The child context.
   */
  constructChild($child) {
    const hasClass = cls => $child.find(cls).length > 0;
    const findObject = cls => $child.find(cls).first();

    if (hasClass('.js-struct-field')) {
      // check to see if there is a generic list between this struct and the found struct child
      if (findObject('.js-struct-field')
        .parentsUntil('.js-struct-child').has('.js-generic-list-field').length) {
        return new yext.location.GenericList(
          findObject('.js-generic-list-context'),
          this.context,
          true /* isChild */);
      }
      return new yext.location.Struct(
        findObject('.js-struct-field'),
        this.context,
        true /* isChild */);
    } else if (hasClass('.js-generic-list-context')) {
      return new yext.location.GenericList(
        findObject('.js-generic-list-context'),
        this.context,
        true /* isChild */);
    } else if (hasClass('.js-youTube-video-field')) {
      return new yext.entity.fields.video.YouTubeVideoField(
        findObject('.js-youTube-video-field'),
        false,
        this.$viewDisplay.find(`[data-prop-name='${$child.attr('data-prop-name')}']`));
    } else if (hasClass('.js-image-type-field')) {
      let $ctx = findObject('.js-image-type-field');
      let $imageCtx = $ctx.find('.js-image-field');
      $imageCtx.removeData('image');

      new yext.location.image.Image($imageCtx);
      return new yext.location.image.ImageField(
        findObject('.js-image-type-field'),
        {uploadUrl: ''});
    } else if (hasClass('.js-daily-times-field')) {
      return yext.location.custom.times.daily.create(findObject('.js-daily-times-field'));
    } else if (hasClass('.js-hours-field')) {
      return new yext.location.hours.DayHours(findObject('.js-hours-field'), null);
    } else if (hasClass('.js-rich-text-field')) {
      return new yext.location.RichText(findObject('.js-rich-text-field'), null);
    } else if (hasClass('.js-date-field')) {
      return new yext.location.Date(findObject('.js-date-field'));
    } else if (hasClass('.js-option-list-field')) {
      return new yext.location.OptionList(findObject('.js-option-list-field'));
    } else if (hasClass('.js-reference-value-list-field')) {
      return new yext.location.ReferenceValueList(findObject('.js-reference-value-list-field'));
    } else if (hasClass('.js-single-select-field')) {
      return new yext.location.Select(findObject('.js-single-select-field'));
    } else if (hasClass('.js-number-field')) {
      return new yext.location.Number(findObject('.js-number-field'));
    } else if (hasClass('.js-text-field')) {
      return yext.textfield.create(findObject('.js-text-field'));
    } else {
      throw new TypeError('Unsupported child type for struct');
    }
  }
};

yext.location.GenericList = class {
  constructor($ctx, context, isChild = false) {
    this.$ctx = $ctx;
    this.$addItemMessage = this.$ctx.find('.js-add-item').last();
    this.$maxItemMessage = this.$ctx.find('.js-max-item-message').last();
    this.context = context;
    // the ul wrapping the list fields
    this.$list = this.$ctx.find('.js-generic-list-field').first();
    // hidden input to store list json data
    this.$fieldValue = this.$ctx.find('.js-generic-list-field-value').first();
    // hidden input to trigger item additions
    this.$itemAdded = this.$ctx.find('.js-generic-list-item-added').first();
    // view message when list is empty
    this.clickToAddMsg = this.$ctx.find('.js-click-to-add-msg').data('template');
    // various content message for bulk edit
    this.variousContentMsg = this.$ctx.find('.js-various-content-msg').data('template');
    this.$assetIdValue = this.$ctx.find('.js-list-asset-id').first();

    this.fieldName = this.$ctx.find('.js-generic-list-name').first().data('listName');
    this.fieldId = isChild
      ? this.$ctx.parents('.js-struct-edit, .js-generic-list-edit').last().find('.js-field-id').first().val()
      : this.$ctx.find('.js-field-id').first().val();
    this.typeId = this.$ctx.find('.js-list-type').first().data('listType');

    // template for new list item view
    this.$itemViewTemplate =
      $($ctx.find('[data-view-template-type-name=\'' + this.fieldName + '\']').data('template'));
    // template for new list item edit
    if ($ctx.hasClass('js-generic-list-context')) {
      this.$itemTemplate =
        $($ctx.children('.js-generic-list-edit')
          .children('[data-template-type-name=\'' + this.fieldName + '\']')
          .data('template'));
    } else {
      this.$itemTemplate =
        $($ctx.children('[data-template-type-name=\'' + this.fieldName + '\']').data('template'));
    }

    this.$viewDisplay =
      this.$ctx.closest('.js-generic-list-context').find('.js-generic-list-display').first();

    this.maxItemCount = this.$list.data('maxItemCount');
    this.orderVaries = this.$list.data('orderVaries');
    this.numElided = this.$list.data('numElided');
    this.isBulkEdit = this.$list.data('isBulkEdit') || false;
    this.numElidedCopy = this.numElided;
    this.timestamp = this.$ctx.data('timestamp');

    // make a copy of $list
    this.$listCopy = this.findDescendantAndSiblings(this.$list, 'li.js-generic-list-item-container').clone(false);

    // parse values into a model backed list
    this.model = this.parseList(this.findDescendantAndSiblings(this.$list, 'li.js-generic-list-item-container'));
    this.originalValues = this.storeOriginalValues(this.model);
    this.assetOrOriginal = true;
    this.itemsShown = false;

    // bindings
    this.bindCheckboxes();
    this.bindReorder();
    this.bindRemoveItem();
    this.bindAddItem();
    this.bindUpdated();
    this.bindShowItems();
  }

  /**
   * Empty lists begin hidden. When the "+ Add" button is clicked, an empty item and
   * the "Add an item" button are shown.
   */
  bindShowItems() {
    let self = this;
    let key = this.fieldName;

    this.$ctx.find('.js-show-list-items[data-associated-list-name=\'' + key + '\']').map(function() {
      let messageContainer = $(this).closest('.js-show-list-items-message');

      $(this).on('click', () => {
        messageContainer.hide();
        self.$ctx.find('.js-generic-list-field[data-list-name=\'' + key + '\']').show();
        self.$ctx.find('.js-add-item-container[data-list-name=\'' + key + '\']').show();
        self.itemsShown = true;
      });
    });
  }

  /**
   * Find the descendant and its siblings with the specified selector
   */
  findDescendantAndSiblings(base, selector) {
    return base.find(selector)
      .first()
      .siblings(selector)
      .addBack();
  }

  /**
   * Store original item json data for comparison later.
   */
  storeOriginalValues(model) {
    let originalValues = {};
    for (let i in this.model) {
      originalValues[i] = this.model[i].getJSONData();
    }
    return originalValues;
  }

  /**
   * Parses each li of the given list into their object representation
   * and stores it as a map where each key is the index of the element in
   * the given list.
   *
   * @param {!jQuery} A list of li elements.
   * @return {!Object} An underlying representation of the list field.
   */
  parseList($list) {
    const self = this;
    let model = {};
    $list.each(function(i) {
      let $this = $(this);
      $this.data('index', i);
      let item = self.constructListItem($this);
      model[i] = item;
    });
    return model;
  }

  /**
   * Adds an empty item to the list.
   */
  addEmptyItem() {
    let $li = this.$itemTemplate.clone();
    this.$list.append($li);
    let item = this.constructListItem($li);

    // init any new select boxes
    if ($li.find('select').length > 0) {
      $li.find('select').selectbox();
    }

    // now allowing asset only users to add a new item, need to reblock inputs
    if (item instanceof yext.location.Struct && item.isAssetsOnly) {
      item.blockInputs();
    }

    let index = Object.keys(this.model).length;
    $li.data('index', index);
    this.model[index] = item;

    this.$itemAdded.trigger('change');
  }

  /**
   * Constructs a list item from the item dom object.
   *
   * Binds list item updates to generic list updates. All list items
   * must broadcast an 'update.list' message in order to
   * trigger the list update.
   *
   * @param {!jQuery} $item
   */
  constructListItem($item) {
    const hasClass = cls => $item.find(cls).length > 0;
    const findObject = cls => $item.find(cls).first();

    let item;
    if (hasClass('.js-struct-field')) {
      item = new yext.location.Struct(
        findObject('.js-struct-edit'),
        this.context,
        true /* isChild */);
    } else if (hasClass('.js-youTube-video-field')) {
      item = new yext.entity.fields.video.YouTubeVideoField(
        findObject('.js-youTube-video-field'),
        false,
        null,
        true);
    } else if (hasClass('.js-image-type-field')) {
      let $ctx = findObject('.js-image-type-field');
      let $imageCtx = $ctx.find('.js-image-field');
      $imageCtx.removeData('image');

      new yext.location.image.Image($imageCtx);
      item = new yext.location.image.ImageField($ctx, {uploadUrl: ''});
    } else if (hasClass('.js-date-field')) {
      item = new yext.location.Date(findObject('.js-date-field'));
    } else if (hasClass('.js-rich-text-field')) {
      item = new yext.location.RichText(findObject('.js-rich-text-field'));
    } else if (hasClass('.js-hours-field')) {
      item = new yext.location.hours.DayHours(findObject('.js-hours-field'), null);
    } else if (hasClass('.js-daily-times-field')) {
      item = yext.location.custom.times.daily.create(findObject('.js-daily-times-field'));
    } else if (hasClass('.js-single-select-field')) {
      item = new yext.location.Select(findObject('.js-single-select-field'));
    } else if (hasClass('.js-number-field')) {
      item = new yext.location.Number(findObject('.js-number-field'));
    } else if (hasClass('.js-simple-text-field')) {
      item = yext.textfield.createWithFieldId(findObject('.js-simple-text-field'), this.fieldId);
    } else {
      throw new TypeError('Unsupported field type in generic list');
    }
    $(item).on('update.list', () => $(this).trigger('updated'));
    $(item).on('nonAssetClearingUpdate.list', () => $(this).trigger('nonAssetClearingUpdate'));
    return item;
  }

  previewAsset(fieldValues, $display) {
    let newItems = fieldValues.items;

    // more asset items than field items
    for (let i = 0; i < newItems.length; i++) {
      if (i >= Object.keys(this.model).length) {
        this.addEmptyItem();
      }
    }

    // more field items than asset items
    for (let i = Object.keys(this.model).length - 1; i >= newItems.length; i--) {
      this.$list.find('.js-remove-item:eq(' + i + ')').trigger('click');
    }

    // TODO: move list of params into a params object
    this.setFromStruct(fieldValues, $display ? $display : this.$viewDisplay, undefined /* viewTemplate */, true /* cannotEdit */);
  }

  /**
   * Apply asset values to all items. Similar to setFromStruct but does not store values into
   * item field's backing models/stored values.
   */
  applyAsset(fieldValues) {
    let newItems = fieldValues.items;

    // remove extra items
    for (let i = Object.keys(this.model).length - 1; i >= newItems.length; i--) {
      this.$list.find('.js-remove-item:eq(' + i + ')').trigger('click');
    }

    // apply asset values
    for (let i = 0; i < newItems.length; i++) {
      // add empty item if necessary
      if (i >= Object.keys(this.model).length) {
        this.addEmptyItem();
      }
      let item = this.model[i];
      let fieldValue = newItems[i];

      item.applyAsset(fieldValue);
    }

    this.updateAssetOrOriginal(true);
  }

  /**
   * The after save function for a top-level generic list. Slightly modifies data and passes
   * to setFromStruct.
   */
  afterSave(response) {
    this.setFromStruct(response.field, this.$viewDisplay);
  }

  /**
   * The after save function when a generic list is a child of a struct.
   * For now, this applies to all generic list fields.
   */
  setFromStruct(fieldValues, $display, $viewTemplate, cannotEdit) {
    let newItems = fieldValues.items;
    let $viewItems = this.findDescendantAndSiblings($display, 'li');

    // remove unchecked items in bulk edit
    if (this.isBulkEdit) {
      this.findDescendantAndSiblings(this.$list, 'li.js-generic-list-item-container')
        .each(function(i) {
          let $item = $(this);
          let $checkbox = $item.find('.js-generic-list-item-checkbox');
          let checked = $checkbox.prop('checked');
          if (checked !== undefined && !checked) {
            $item.remove();
          }
        });
      // updating model because an unchecked item might have been deleted.
      this.model = this.parseList(
        this.findDescendantAndSiblings(this.$list, 'li.js-generic-list-item-container'));
    }

    let hasIndeterminateItems = this.hasIndeterminateItems();

    for (let i = 0; i < newItems.length; i += 1) {
      let item = this.model[i];
      let fieldValue = newItems[i];
      let viewItem = $viewItems.get(i);

      if (viewItem !== undefined) {
        item.setFromStruct(fieldValue, $(viewItem), this.$itemViewTemplate.clone(), cannotEdit);
      } else {
        // new item, add to view
        let $li = this.$itemViewTemplate.clone();
        $li.find('.js-struct-children-wrapper').show();
        // when applying an asset with more items than currently in the list we need to add
        // a new item to the model in order to setFromStruct on it
        // TODO: Make this specialized for the preview asset case.
        if (item === undefined) {
          this.addEmptyItem();
          item = this.model[i];
        }
        item.setFromStruct(fieldValue, $li, $li, cannotEdit);
        if (!this.isBulkEdit || !hasIndeterminateItems) {
          $display.find('ul.js-generic-list-view').first().append($li);
        }
      }
    }

    // remove extra elements
    for (let i = newItems.length; i < $viewItems.length; i += 1) {
      $viewItems.get(i).remove();
    }

    // clear 'click to add' message if it exists
    $display.find('.various').remove();
    $display.find('.emptyvalue').remove();
    if (newItems.length == 0) {
      $display.append(this.clickToAddMsg);
      this.addEmptyItem();
    } else if (newItems.length > 0 && this.isBulkEdit) {
      // show <Various Content> msg when any item is indeterminate
      if (hasIndeterminateItems) {
        $display.append(this.variousContentMsg);
      }
    }

    this.$listCopy = this.findDescendantAndSiblings(this.$list, 'li.js-generic-list-item-container').clone(false);
    // after a submission dont hide the edit structure
    this.itemsShown = false;
    // this syncs the edit view to the current state
    this.reset();

    this.clearAsset();
    this.originalValues = this.storeOriginalValues(this.model);
  }

  /**
   * Only applicable during bulk edit mode. This methods checks if any item checkboxes
   * exist with an indeterminate value.
   */
  hasIndeterminateItems() {
    let itemIndeterminateFlags = this.$list.find('.js-generic-list-item-checkbox')
      .map(function() {
        return $(this).prop('indeterminate');
      })
      .toArray();
    return itemIndeterminateFlags.reduce((acc, i) => acc || i, false);
  }

  /**
   * Triggers 'updated' message when a list item's indeterminate
   * checkbox is updated.
   */
  bindCheckboxes() {
    let self = this;
    this.$list.find('.js-generic-list-item-checkbox')
      .each(function() {
        let $checkbox = $(this);
        let indeterminate = $checkbox.data('indeterminate');
        if (indeterminate) {
          $checkbox.prop('indeterminate', indeterminate);
        }
        $checkbox.on('change', function() {
          if (indeterminate) {
            $checkbox.prop('checked', true);
            indeterminate = false;
          }
          $(this).attr('data-indeterminate', false);
          $(self).trigger('updated');
        });
      });
  }

  /**
   * Syncs the order of the DOM with the order of the model.
   */
  bindReorder() {
    var params = {
      handle: '.js-reorder-item',
      axis: 'y',
      stop: (e, ui) => {
        this.updateModelIndices();
        $(this).trigger('updated');
        ui.item
          .css('top', 'auto')
          .css('left', 'auto');
      },
      containment: this.$list,
      tolerance: 'pointer',
      cursorAt: {left: 8, top: 20},
    };
    if (this.isListOfStruct()) {
      // Only collapse and show special placeholder if there is a child that is a struct
      params['placeholder'] = 'generic-list-placeholder';
      params['helper'] = () => {
        var helper = $('.generic-list-helper', this.$ctxt).clone();
        helper.css('display', '');
        return helper;
      };
    }

    this.$list.sortable(params);
  }

  isListOfStruct() {
    return this.$list.has('.js-struct-field').length > 0;
  }

  /**
   * Bind add item interaction.
   */
  bindAddItem() {
    let $addItem;
    if (this.$ctx.hasClass('js-generic-list-context')) {
      $addItem = this.$ctx
        .children('.js-generic-list-edit')
        .children('.js-add-item-container')
        .children('.js-add-item');
    } else {
      $addItem = this.$ctx
        .children('.js-add-item-container')
        .children('.js-add-item');
    }

    $addItem.on('click', () => {
      let size = Object.keys(this.model).length;
      if (this.maxItemCount == null || size < this.maxItemCount) {
        this.addEmptyItem();
      }

      // limit max number of items if over
      if (this.maxItemCount != null && size + 1 >= this.maxItemCount) {
        this.$addItemMessage.hide();
        this.$maxItemMessage.show();
      }
      this.updateAssetOrOriginal(false);
    });
  }

  /**
   * Bind remove item interaction and remove elided items interaction.
   */
  bindRemoveItem() {
    const self = this;
    this.$list.on('click', '.js-remove-item', function() {
      let $li = $(this).closest('li');
      let index = $li.data('index');
      delete self.model[`${index}`];
      $li.remove();

      // updating indices
      self.updateModelIndices();
      $(self).trigger('updated');

      // remove max items limit if under
      let size = Object.keys(self.model).length;
      if (size < self.maxItemCount) {
        self.$addItemMessage.show();
        self.$maxItemMessage.hide();
      }
      self.updateAssetOrOriginal(false);
    });

    this.$ctx.find('.js-remove-elided-items').on('click', () => this.removeAllElided());
  }

  removeAllElided() {
    this.numElided = 0;
    this.$ctx.find('.js-elided-message').text(yext.msg('0 items'));
    $(this).trigger('update.struct');
  }

  /**
   * Updates the index keys of the model to reflect the order
   * of the li elements.
   */
  updateModelIndices() {
    let oldModel = this.model;
    this.model = {};
    const self = this;
    this.findDescendantAndSiblings(this.$list, 'li.js-generic-list-item-container').each(function(i) {
      let $this = $(this);
      let oldIndex = $this.data('index');
      self.model[i] = oldModel[oldIndex];
      $this.data('index', i);
    });
  }

  /**
   * Reset the model to the stored state.
   */
  reset() {
    const self = this;
    let key = this.fieldName;

    this.$list.empty();
    this.$listCopy.each(function(i) {
      let $li = $(this).clone();
      $li.data('index', i);
      $li.find('.selectbox').remove();
      $li.find('select').selectbox();
      self.$list.append($li);
    });
    this.model = this.parseList(this.findDescendantAndSiblings(this.$list, 'li.js-generic-list-item-container'));
    this.initializeNewDatepickers(this.$list.find('.js-date-input'));

    // re-render old values
    this.numElided = this.oldNumElided;
    let elidedMessage = yext.msgn('1 item', '{0} items', this.oldNumElided);
    this.$ctx.find('.js-elided-message').text(elidedMessage);

    if (this.itemsShown) {
      this.$ctx.find('.js-show-list-items-message[data-associated-list-name=\'' + key + '\']').show();
      this.$ctx.find('.js-generic-list-field[data-list-name=\'' + key + '\']').hide();
      this.$ctx.find('.js-add-item-container[data-list-name=\'' + key + '\']').hide();
      this.itemsShown = false;
    }

    this.bindCheckboxes();
  }

  /**
   * Binds listener for 'updated' events, which sets the field value
   * and triggers 'update.struct'
   */
  bindUpdated() {
    $(this).on('updated', () => {
      this.setFieldValue();
      this.$assetIdValue.val('');
      $(this).trigger('update.struct');
    });

    $(this).on('nonAssetClearingUpdate', () => {
      this.setFieldValue();
      $(this).trigger('nonAssetClearingUpdate.struct');
    });
  }

  /**
   * Sets the hidden input with the fields name to
   * the JSON string value of the field.
   */
  setFieldValue() {
    let jsonValue = yext.JSON.stringify(this.getJSONData());
    this.$fieldValue.val(jsonValue);
  }

  /**
   * Maps all list items into their JSON value and marshals them into a list.
   */
  getJSONData() {
    let items = [];
    let $items = this.findDescendantAndSiblings(this.$list, 'li.js-generic-list-item-container');
    for (let i in this.model) {
      let item = this.model[i].getJSONData();
      let $item = $($items.get(i));
      let $checkbox = $item.find('.js-generic-list-item-checkbox');
      let checked = $checkbox.prop('checked');
      if (checked === undefined || checked) {
        item.indeterminate = $checkbox.prop('indeterminate') || false;
        items.push(item);
      }
    }
    let jsonData = {items};

    if (this.$assetIdValue.val()) {
      jsonData['assetId'] = this.$assetIdValue.val();
    }

    return jsonData;
  }

  /**
    * Called right before submission, this function reconciles asset ids of the list and all of
    * its items. If this is an asset submission, fills the field value with JSON data containing
    * any existing asset ids of this list and its items. If this is an edit submission, clears
    * all asset ids of this list and its items.
    */
  reconcileAsset() {
    let assetSubmission = this.checkAssetOrOriginalFlag();

    if (assetSubmission) {
      // reconcile asset - add asset ids to json blobs and fill field value hidden input
      for (let i in this.model) {
        let jsonData = this.getJSONData();
        this.$fieldValue.val(yext.JSON.stringify(jsonData));
      }
    } else {
      // edit submission - clear all asset flags
      this.clearAsset();
      this.setFieldValue();
    }
  }

  /**
   * Update the asset or original flag.
   */
  updateAssetOrOriginal(fromAsset) {
    if (fromAsset
        || yext.JSON.stringify(this.originalValues) ===
            yext.JSON.stringify(this.storeOriginalValues(this.model))) {
      this.assetOrOriginal = true;
    } else {
      this.assetOrOriginal = false;
    }
  }

  /**
   * Check the for unchanged or assetOrOriginal flag of all items. If all are true, this is an
   * asset submission. If any are false this is an edit submission.
   */
  checkAssetOrOriginalFlag() {
    if (Object.keys(this.originalValues).length !== Object.keys(this.model).length
        && !this.assetOrOriginal) {
      return false;
    }

    for (let i in this.model) {
      let originalValue = this.originalValues[i];
      let modelValue = this.model[i].getJSONData();

      if (yext.JSON.stringify(originalValue) !== yext.JSON.stringify(modelValue)
          && !this.model[i].checkAssetOrOriginalFlag()) {
        return false;
      }
    }
    return true;
  }

  /**
   * Clear asset ids from hidden inputs of this list and all of its items.
   */
  clearAsset() {
    this.$assetIdValue.val('');

    for (let i in this.model) {
      let item = this.model[i];
      // if item type can have asset id, wipe it out
      if (item instanceof yext.location.Struct
          || item instanceof yext.location.GenericList
          || item instanceof yext.entity.fields.video.YouTubeVideoField
          || item instanceof yext.location.image.Image
          || item instanceof yext.textfield.TextField) {
        item.clearAsset();
      }
    }
  }

  /**
   * This method recursively modifies those image field values associated with files so they have a
   * 'fileIndex' variable and their 'url' is cleared. The 'fileIndex' corresponds uniquely to which
   * file in the eventual form they correspond to. The behavior in here is similar to what was done in
   * ImageUploader.upload. Finally, the method returns all the files that will need to be uploaded
   * in the form, sorted properly.
   */
  orderAndAssociateImageFiles(
    parsedFieldValue = window.JSON.parse(this.$fieldValue.val()),
    imageFiles = []) {
    for (let i in this.model) {
      var item = this.model[i];
      if (item instanceof yext.location.GenericList || item instanceof yext.location.Struct) {
        item.orderAndAssociateImageFiles(parsedFieldValue.items[i], imageFiles);
      } else {
        if (item.getAssociatedFile) {
          var associatedFile = item.getAssociatedFile();
          if (!window.jQuery.isEmptyObject(associatedFile)) {
            parsedFieldValue.items[i]['url'] = undefined;
            parsedFieldValue.items[i]['fileIndex'] = imageFiles.length;
            imageFiles.push(associatedFile['file']);
          }
        }
      }
    }

    this.$fieldValue.val(window.JSON.stringify(parsedFieldValue));

    return imageFiles;
  }

  /**
   * Helper method to initialize new datepickers after resetting and cloning list copy.
   * @suppress {deprecated}
   */
  initializeNewDatepickers($selector) {
    var self = this;
    $selector.each(function() {
      $(this).removeClass('hasDatepicker')
        .removeData('datepicker')
        .datepicker({
          dateFormat: 'mm/dd/yy',
        });
      $(this).on('update.list', () => self.trigger('updated'));
    });
  }

  clear() {
    this.$list.empty();
    this.removeAllElided();
    this.model = this.parseList(this.findDescendantAndSiblings(
      this.$list,
      'li.js-generic-list-item-container'));
    this.addEmptyItem();
    // reset asset approvals values
    this.updateAssetOrOriginal(false);
  }
};
